import * as locale from 'locale';

import type { Options } from './i18n.types';
import { makeFormat } from './makeFormat';

const rawStrings = {
  ...locale.strings,
  axis: locale.axis,
  exports: locale.exports,
  labels: locale.labels,
  social: locale.social,
  actions: locale.actions,
  notifications: locale.notifications,
  notificationsGrouped: locale.notificationsGrouped,
};

export const forNamespace = (
  ns: string | string[] = [],
  {
    shouldEscapeStrings = true,
    returnBlankForMissingStrings = false,
    canOmitSubstitutions = false,
  }: Options = {},
) =>
  makeFormat(
    Array.isArray(ns) ? ns : [ns],
    rawStrings,
    'en.json in strings files',
    shouldEscapeStrings,
    returnBlankForMissingStrings,
    canOmitSubstitutions,
  );
